import React from 'react'

const UploadIcon = ({color = 'currentColor', width = 24, height = 24, ...rest}) => (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
        <path
            d="M17.2201 7.21375L12.8451 2.21375C12.7263 2.07875 12.5551 2 12.3751 2C12.1951 2 12.0238 2.07875 11.9051 2.21375L7.53008 7.21375C7.36883 7.39875 7.32883 7.66 7.43133 7.88375C7.48104 7.9929 7.56108 8.08546 7.66192 8.15039C7.76276 8.21533 7.88014 8.2499 8.00008 8.25H10.5001V16.375C10.5001 16.72 10.7801 17 11.1251 17H13.6251C13.9701 17 14.2501 16.72 14.2501 16.375V8.25H16.7501C16.8701 8.25016 16.9876 8.21569 17.0884 8.15072C17.1893 8.08576 17.2693 7.99306 17.3188 7.88375C17.4201 7.66 17.3826 7.3975 17.2201 7.21375Z"
            fill={color}
        />
        <path
            d="M19.25 15.75V19.5H5.5V15.75H3V20.75C3 21.4412 3.56 22 4.25 22H20.5C21.1912 22 21.75 21.4412 21.75 20.75V15.75H19.25Z"
            fill={color}
        />
    </svg>
)

export default UploadIcon
